import React from 'react';

import Css from './LabelInput.scss';

const labelInput = props => {
  return (
    <div className={Css['form-control']}>
      <label htmlFor={'input-' + props.name} className={'asap-bold'}>
        {props.label}
      </label>
      <input
        type={props.type}
        name={props.name}
        id={'input-' + props.name}
        placeholder={props.label}
        onChange={
          props.onChange !== undefined ? event => props.onChange(event) : null
        }
        value={props.value}
      />
    </div>
  );
};

export default labelInput;



// WEBPACK FOOTER //
// ./src/components/LabelInput/LabelInput.js